import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const AssetTypeSettingsViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
AssetTypeSettingsViewTopBar.displayName = "AssetTypeSettingsViewTopBar"
